import React, { useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";

export const AutoLoginComponent = () => {
  const { loginWithRedirect } = useAuth0();

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const sessionTransferToken = urlParams.get('session_transfer_token');

    if (sessionTransferToken) {
      // query method
      loginWithRedirect({
        authorizationParams: {
          redirect_uri: `https://${window.location.host}/profile`,
          session_transfer_token: sessionTransferToken
        }
      });
    } else {
      // cookie method
      loginWithRedirect({
        authorizationParams: {
          redirect_uri: `https://${window.location.host}/profile`
        }
      });
    }
  }, [loginWithRedirect]); // The empty dependency array ensures this effect runs only once after the initial render.
                          // loginWithRedirect is included as a dependency to ensure the effect is re-run if it changes,
                          // though for useAuth0 it's usually stable.

  return (
    <div>Automatically Logging in...</div>
  );
};

export default AutoLoginComponent;
